import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { RestapiService } from '@services/restapi.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnDestroy {
  subscription: Subscription;
  content: any;

  constructor(
    private restAPI: RestapiService
  ) {
    this.subscription = this.restAPI.getS3FileAPI('landingPage/landingPage-footer.md').subscribe((data) => {
      this.content = data;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
